import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material'
import { UseFormSetValue } from 'react-hook-form'

import { FirstComeFirstServedEditValues } from '@/components/pages/ConsolePreSaleEdit/template/FirstComeFirstServedEditForm'
import { LotteryEditValues } from '@/components/pages/ConsolePreSaleEdit/template/LotteryEditForm'
import { tLabel, useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

import { FirstComeFirstServedCreateValues } from '../FirstComeFirstServedCreateForm'
import { LotteryCreateValues } from '../LotteryCreateForm'

type PaymentMethodsInputCellProps = {
  setValue:
    | UseFormSetValue<LotteryCreateValues>
    | UseFormSetValue<LotteryEditValues>
    | UseFormSetValue<FirstComeFirstServedCreateValues>
    | UseFormSetValue<FirstComeFirstServedEditValues>
  paymentMethods: string
  disabled?: boolean
}

export const paymentMethodsValue = {
  both: 'both',
  konbini: 'konbini',
  credit_card: 'credit_card',
} as { [key: string]: PaymentMethodsValue }

export type PaymentMethodsValue = 'both' | 'konbini' | 'credit_card'

export const PaymentMethodsInputCell: Cell<PaymentMethodsInputCellProps> = ({
  setValue,
  disabled,
  paymentMethods,
}) => {
  const { t } = useTranslation('consolePreSaleCreate')

  return (
    <CellFrame sx={{ pb: 7 }}>
      <Typography variant="h5">{t('paymentMethodsTitle')}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ pt: 2 }}>
        {t('paymentMethodsDesc')}
      </Typography>
      <RadioGroup
        onChange={(_, value) => {
          // @ts-ignore
          setValue('paymentMethods', value, {
            shouldDirty: true,
          })
        }}
        sx={{ display: 'flex', flexDirection: 'column', gap: 0, mt: 1 }}
        value={paymentMethods}
      >
        <FormControlLabel
          disabled={disabled}
          value={paymentMethodsValue.both}
          control={<Radio />}
          label={tLabel('consolePreSaleCreate.paymentMethodsType.both')}
        />
        <FormControlLabel
          disabled={disabled}
          value={paymentMethodsValue.credit_card}
          control={<Radio />}
          label={tLabel('consolePreSaleCreate.paymentMethodsType.credit_card')}
        />
        <FormControlLabel
          disabled={disabled}
          value={paymentMethodsValue.konbini}
          control={<Radio />}
          label={tLabel('consolePreSaleCreate.paymentMethodsType.konbini')}
        />
      </RadioGroup>
    </CellFrame>
  )
}
